/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, boolean as codecBoolean, number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { FrontendSiteSettings } from './FrontendSiteSettings';
const AllSiteSettingsParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    [
        'AUTO_TEST_HEARTBEAT_INTERVAL',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'AUTO_TEST_HEARTBEAT_MAX_MISSED',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'AUTO_TEST_MAX_JOBS_PER_RUNNER',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'AUTO_TEST_MAX_CONCURRENT_BATCH_RUNS',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'AUTO_TEST_MAX_RESULT_NOT_STARTED',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'AUTO_TEST_MAX_UNIT_TEST_METADATA_LENGTH',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'NEW_AUTO_TEST_MAX_DYNAMODB_SIZE',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'NEW_AUTO_TEST_MAX_STORAGE_SIZE',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'NEW_AUTO_TEST_MAX_FILE_SIZE',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'NEW_AUTO_TEST_BUILD_OUTPUT_LIMIT',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'NEW_AUTO_TEST_TEST_OUTPUT_LIMIT',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'NEW_AUTO_TEST_MAX_OUTPUT_FILES_SIZE',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'NEW_AUTO_TEST_ALLOWED_INITIAL_BUILD_IDS',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(codecString)),
    ],
    [
        'NEW_AUTO_TEST_INITIAL_BUILD_ID',
        /* #__PURE__ */ codecOptional(codecString),
    ],
    ['MIN_PASSWORD_SCORE', /* #__PURE__ */ codecOptional(codecNumber)],
    ['SETTING_TOKEN_TIME', /* #__PURE__ */ codecOptional(parsers.duration)],
    ['MAX_NUMBER_OF_FILES', /* #__PURE__ */ codecOptional(codecNumber)],
    ['MAX_LARGE_UPLOAD_SIZE', /* #__PURE__ */ codecOptional(codecNumber)],
    ['MAX_NORMAL_UPLOAD_SIZE', /* #__PURE__ */ codecOptional(codecNumber)],
    ['MAX_DYNAMO_SUBMISSION_SIZE', /* #__PURE__ */ codecOptional(codecNumber)],
    ['MAX_FILE_SIZE', /* #__PURE__ */ codecOptional(codecNumber)],
    ['MAX_DYNAMO_FILE_SIZE', /* #__PURE__ */ codecOptional(codecNumber)],
    ['MAX_DOCUMENT_UPDATE_SIZE', /* #__PURE__ */ codecOptional(codecNumber)],
    [
        'JWT_ACCESS_TOKEN_EXPIRES',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'SSO_USERNAME_DECOLLISION_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['MAX_USER_SETTING_AMOUNT', /* #__PURE__ */ codecOptional(codecNumber)],
    ['SEND_REGISTRATION_EMAIL', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'AUTOMATIC_LTI_1P3_ASSIGNMENT_IMPORT',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'LTI_UNSET_DEADLINE_LOCK_DATE_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'LTI_1P3_SYSTEM_ROLE_FROM_CONTEXT_ROLE',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['LTI_LAUNCH_DATA_LOGGING', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['PEARSON_TEMPLATES', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'DEFAULT_COURSE_TEACHER_ROLE',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('Full Teacher', 'Non-Editing Teacher')),
    ],
    [
        'DEFAULT_COURSE_TA_ROLE',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('Full TA', 'Non-Editing TA')),
    ],
    [
        'LTI_1P3_NONCE_AND_STATE_VALIDATION_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'LTI_1P3_PREVENT_NONCE_REUSE_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'NAME_AND_EMAIL_FROM_NRPS_ONLY',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'ALWAYS_UPDATE_PII_WITH_LTI',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['HUBSPOT_SYNCING_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['IS_PEARSON', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['LTI_ROLE_SWITCHING', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'PER_COURSE_PAYMENT_ALLOWED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'PAYMENTS_PROVIDER',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('paddle', 'stripe')),
    ],
    [
        'RUBRIC_CONVERT_USE_ATV2_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
])), FrontendSiteSettings);
export class AllSiteSettings extends FrontendSiteSettings {
    static decode(input) {
        return AllSiteSettingsParser.decode(input).map(res => new AllSiteSettings(res));
    }
    static unsafeDecode(input) {
        return AllSiteSettings.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AllSiteSettingsParser.encode(data);
    }
    static schema() {
        return AllSiteSettingsParser.schema();
    }
}
